import API from './api';

export const saudiService = {
  // Ingestion
  uploadReport: (file, reportDate, duplicateAction) => {
    const formData = new FormData();
    formData.append('file', file);
    if (reportDate) formData.append('report_date', reportDate);
    if (duplicateAction) formData.append('duplicate_action', duplicateAction);
    return API.post('/api/saudi-weekly/upload/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    });
  },
  bulkUpload: (files) => {
    const formData = new FormData();
    files.forEach(f => formData.append('files', f));
    return API.post('/api/saudi-weekly/upload/bulk/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 300000,
    });
  },
  previewExtract: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return API.post('/api/saudi-weekly/upload/preview/', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    });
  },
  getUploadHistory: () => API.get('/api/saudi-weekly/upload/history/'),

  // Flows
  getFlowsOverview: (params) => API.get('/api/saudi-weekly/flows/overview/', { params }),
  getFlowsTrend: (params) => API.get('/api/saudi-weekly/flows/trend/', { params }),
  getFlowsBreakdown: (params) => API.get('/api/saudi-weekly/flows/breakdown/', { params }),
  getFlowsComposition: (params) => API.get('/api/saudi-weekly/flows/composition/', { params }),
  getFlowsDetail: (params) => API.get('/api/saudi-weekly/flows/detail/', { params }),

  // Ownership
  getOwnershipSnapshot: (params) => API.get('/api/saudi-weekly/ownership/snapshot/', { params }),
  getOwnershipTrend: (params) => API.get('/api/saudi-weekly/ownership/trend/', { params }),
  getOwnershipChange: (params) => API.get('/api/saudi-weekly/ownership/change/', { params }),
  getOwnershipInstitutional: (params) => API.get('/api/saudi-weekly/ownership/institutional/', { params }),

  // Correlation
  getCorrelation: (params) => API.get('/api/saudi-weekly/correlation/', { params }),
};
